<div class="summary">

  <!-- Bowling summary replaces podium + stats + confetti for the bowling game -->
  <app-bowling-summary
    *ngIf="session?.gameType === MiniGameType.BOWLING"
    [session]="session"
    [currLang]="currLang">
  </app-bowling-summary>

  <!-- Full-page confetti (only after podium phase 4, not for Tug of War / Bowling) -->
  <div class="confetti-container" *ngIf="podiumPhase >= 4 && session?.gameType !== MiniGameType.TUG_OF_WAR && session?.gameType !== MiniGameType.BOWLING">
    <div *ngFor="let c of confettiPieces" class="confetti-piece"
         [style.--x]="c.x" [style.--delay]="c.delay" [style.--duration]="c.duration"
         [style.--color]="c.color" [style.--rotation]="c.rotation">
    </div>
  </div>

  <!-- Podium Section (question-based games only) -->
  <div class="podium-section" *ngIf="topStudents.length > 0 && session?.gameType !== MiniGameType.TUG_OF_WAR && session?.gameType !== MiniGameType.BOWLING"
       [class.phase-1]="podiumPhase === 1"
       [class.phase-2]="podiumPhase === 2"
       [class.phase-3]="podiumPhase === 3"
       [class.phase-4]="podiumPhase >= 4">

    <!-- Reveal stage: cards stay visible and slide to position -->
    <div class="reveal-stage" *ngIf="podiumPhase >= 1 && podiumPhase <= 3">

      <!-- 3rd place: appears center (phase 1), slides right (phase 2+) -->
      <div class="reveal-card" *ngIf="topStudents[2]"
           [class.at-center]="podiumPhase === 1"
           [class.at-right]="podiumPhase >= 2"
           [class.shrink]="podiumPhase >= 2">
        <div class="reveal-rank bronze-badge">{{ 3 | arabicNumber:currLang }}</div>
        <app-student-avatar [student]="topStudents[2].student" [size]="100" [active]="false"></app-student-avatar>
        <span class="reveal-name">{{ getStudentName(topStudents[2].student) }}</span>
        <span class="reveal-xp">{{ topStudents[2].xp | arabicNumber:currLang }} XP</span>
      </div>

      <!-- 2nd place: appears center (phase 2), slides left (phase 3) -->
      <div class="reveal-card" *ngIf="topStudents[1] && podiumPhase >= 2"
           [class.at-center]="podiumPhase === 2"
           [class.at-left]="podiumPhase >= 3"
           [class.shrink]="podiumPhase >= 3">
        <div class="reveal-rank silver-badge">{{ 2 | arabicNumber:currLang }}</div>
        <app-student-avatar [student]="topStudents[1].student" [size]="100" [active]="false"></app-student-avatar>
        <span class="reveal-name">{{ getStudentName(topStudents[1].student) }}</span>
        <span class="reveal-xp">{{ topStudents[1].xp | arabicNumber:currLang }} XP</span>
      </div>

      <!-- 1st place: appears center (phase 3), stays center -->
      <div class="reveal-card winner" *ngIf="topStudents[0] && podiumPhase >= 3">
        <div class="reveal-crown">🏆</div>
        <div class="reveal-rank gold-badge">{{ 1 | arabicNumber:currLang }}</div>
        <app-student-avatar [student]="topStudents[0].student" [size]="120" [active]="true"></app-student-avatar>
        <span class="reveal-name winner-name">{{ getStudentName(topStudents[0].student) }}</span>
        <span class="reveal-xp">{{ topStudents[0].xp | arabicNumber:currLang }} XP</span>
      </div>

    </div>

    <!-- Final podium (appears at phase 4) -->
    <div class="podium" *ngIf="podiumPhase >= 4">
      <!-- 2nd (left) -->
      <div class="podium-slot silver" *ngIf="topStudents[1]">
        <app-student-avatar [student]="topStudents[1].student" [size]="80" [active]="false"></app-student-avatar>
        <span class="rank-badge silver-badge">{{ 2 | arabicNumber:currLang }}</span>
        <span class="podium-name">{{ getStudentName(topStudents[1].student) }}</span>
        <span class="podium-xp">{{ topStudents[1].xp | arabicNumber:currLang }} XP</span>
        <div class="pillar silver-pillar"><div class="pillar-shine"></div></div>
      </div>

      <!-- 1st (center) -->
      <div class="podium-slot gold" *ngIf="topStudents[0]">
        <div class="crown-icon">🏆</div>
        <app-student-avatar [student]="topStudents[0].student" [size]="100" [active]="true"></app-student-avatar>
        <span class="rank-badge gold-badge">{{ 1 | arabicNumber:currLang }}</span>
        <span class="podium-name">{{ getStudentName(topStudents[0].student) }}</span>
        <span class="podium-xp">{{ topStudents[0].xp | arabicNumber:currLang }} XP</span>
        <div class="pillar gold-pillar"><div class="pillar-shine"></div></div>
      </div>

      <!-- 3rd (right) -->
      <div class="podium-slot bronze" *ngIf="topStudents[2]">
        <app-student-avatar [student]="topStudents[2].student" [size]="68" [active]="false"></app-student-avatar>
        <span class="rank-badge bronze-badge">{{ 3 | arabicNumber:currLang }}</span>
        <span class="podium-name">{{ getStudentName(topStudents[2].student) }}</span>
        <span class="podium-xp">{{ topStudents[2].xp | arabicNumber:currLang }} XP</span>
        <div class="pillar bronze-pillar"><div class="pillar-shine"></div></div>
      </div>
    </div>
  </div>

  <!-- Game name -->
  <h2 class="summary-title" *ngIf="session?.gameType !== MiniGameType.BOWLING">
    <span [innerHTML]="gameIcon"></span> {{ gameName }}
  </h2>

  <!-- Stats Grid (question-based games) -->
  <div class="stats-grid" *ngIf="session?.gameType !== MiniGameType.BOWLING">
    <div class="stat-card">
      <span class="stat-value correct">{{ correctCount | arabicNumber:currLang }}</span>
      <span class="stat-label">{{ currLang === 'ar' ? 'صحيح' : 'Correct' }}</span>
    </div>
    <div class="stat-card">
      <span class="stat-value incorrect">{{ totalCount - correctCount | arabicNumber:currLang }}</span>
      <span class="stat-label">{{ currLang === 'ar' ? 'خطأ' : 'Wrong' }}</span>
    </div>
    <div class="stat-card">
      <span class="stat-value accuracy">{{ accuracy | arabicNumber:currLang }}%</span>
      <span class="stat-label">{{ currLang === 'ar' ? 'الدقة' : 'Accuracy' }}</span>
    </div>
    <div class="stat-card">
      <span class="stat-value xp">{{ totalXP | arabicNumber:currLang }}</span>
      <span class="stat-label">{{ currLang === 'ar' ? 'مجموع XP' : 'Total XP' }}</span>
    </div>
  </div>

  <!-- Game-specific stats -->
  <div class="special-stat" *ngIf="session?.gameType === MiniGameType.TUG_OF_WAR">
    <img class="special-icon" src="assets/game-mode/svg/mvp.svg" alt="" />
    <span class="special-label">{{ currLang === 'ar' ? 'الفائز:' : 'Winner:' }}</span>
    <span class="special-value">{{ tugWinner }}</span>
  </div>


  <!-- Auto-cycle: countdown to next game -->
  <div class="auto-advance-info" *ngIf="autoCycleEnabled && !showTransition">
    <span class="next-game-label">{{ currLang === 'ar' ? 'اللعبة التالية في' : 'Next game in' }}</span>
    <span class="countdown-number">{{ autoAdvanceCountdown | arabicNumber:currLang }}</span>
  </div>

</div>

<!-- Transition overlay: "Next up" splash -->
<div class="transition-overlay" *ngIf="showTransition">
  <div class="transition-content">
    <span class="transition-label">{{ currLang === 'ar' ? 'اللعبة التالية' : 'Next Up' }}</span>
    <span class="transition-icon" [innerHTML]="nextGameIcon"></span>
    <span class="transition-name">{{ nextGameName }}</span>
  </div>
</div>
